import { useState } from "react";
import { AiOutlineAppstoreAdd } from "react-icons/ai";
import { useHistory, useLocation } from "react-router-dom";
import AdminMenu from "../../app/admin/menu/AdminMenu";
import { ADMIN, DASHBOARD, DASHBOARD_LABEL } from "../../constants/routes";
import { useContextState } from "../../context/ContextProvider";
import cn from "../../lib/cn";
import { dashboardSvgIcon, enquiry } from "../../resources/js/icons";
import Container from "../Container";
import P from "../typography/P";
import EnquiryInternalUser from "./EnquiryInternalUser";

const handleActiveTab = (location, path) => {
    if (location.slice(1).toLowerCase().includes(path.slice(1).toLowerCase())) {
        return true;
    } else return false;
};

const AdminTabNavigator = ({ showEnquiry, onClickEnquiry }) => {
    const { state } = useContextState();
    const history = useHistory();
    const location = useLocation();
    // const [showEnquiryModal, setShowEnquiryModal] = useState(false);
    const [openMenu, setOpenMenu] = useState(false);
    const closeModalState = () => {
        setOpenMenu(false);
        onClickEnquiry(false);
    };

    return (
        <>
            {state?.user && (
                <div className="lg:hidden fixed inset-x-0 bottom-0 bg-white py-0.8  border-t border-blue-300  flex items-center z-100">
                    <Container>
                        <div className="flex justify-between ">
                            <div
                                className="flex flex-col items-center hover:cursor-pointer w-6.4"
                                role="button"
                                onClick={() => {
                                    setOpenMenu(false);
                                    onClickEnquiry(false);
                                    history.push(`${ADMIN}${DASHBOARD}`);
                                }}
                            >
                                <div
                                    className={cn("h-[24px]  ", {
                                        "text-blue":
                                            !openMenu &&
                                            handleActiveTab(
                                                location.pathname,
                                                DASHBOARD_LABEL
                                            ),
                                    })}
                                >
                                    {dashboardSvgIcon}
                                </div>

                                <P
                                    className={cn("text-xs font-vietnam", {
                                        "text-blue ":
                                            !openMenu &&
                                            handleActiveTab(
                                                location.pathname,
                                                DASHBOARD_LABEL
                                            ),
                                    })}
                                >
                                    Dashboard
                                </P>
                            </div>
                            <div
                                className="flex flex-col items-center hover:cursor-pointer  bg-linear-blue-white-v2  px-0.8 py-0.5 rounded-sm"
                                role="button"
                                onClick={() => {
                                    setOpenMenu(false);
                                    onClickEnquiry(true);
                                }}
                            >
                                <div
                                    className={cn(
                                        "h-[30px] flex items-center  ",
                                        {
                                            "text-white": true,
                                        }
                                    )}
                                >
                                    {/* <GrDocumentText size={26} /> */}
                                    <img
                                        src={enquiry}
                                        className="h-2.4"
                                        alt="enquiry"
                                    />
                                </div>

                                <P
                                    className={cn({
                                        "text-white text-xs font-vietnam": true,
                                    })}
                                >
                                    Enquiry
                                </P>
                            </div>
                            <div
                                className="flex flex-col items-center hover:cursor-pointer  w-6.4"
                                role="button"
                                onClick={() => {
                                    onClickEnquiry(false);
                                    setOpenMenu(true);
                                }}
                            >
                                <div
                                    className={cn("h-[24px]  ", {
                                        "text-blue": openMenu,
                                    })}
                                >
                                    <AiOutlineAppstoreAdd size={24} />
                                </div>

                                <P
                                    className={cn("text-xs font-vietnam", {
                                        "text-blue ": openMenu,
                                    })}
                                >
                                    Menu
                                </P>
                            </div>
                        </div>
                    </Container>
                </div>
            )}

            <EnquiryInternalUser
                isOpen={showEnquiry}
                onClose={() => onClickEnquiry(false)}
            />
            <AdminMenu isOpen={openMenu} onClick={(val) => setOpenMenu(val)} />
        </>
    );
};

export default AdminTabNavigator;
